export default __webpack_public_path__ + "static/media/logoweb.a2c423af.png";